// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__uDAPp","title":"BackImages_title__2rO-G","images":"BackImages_images__3je7Q"};